<template>
  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">

      <material-card
        :title="$t('consequenceStrengths.edit.title')"
        :text="$t('consequenceStrengths.edit.text')"

      >

        <v-form @submit.prevent="editConsequenceStrengths">
          <v-container >
            <v-row
              v-for="(consequenceStrength, i) in consequenceStrengths"
              :key="i"
            >

              <v-col
                cols="12"
             >

                <v-text-field
                  v-model="consequenceStrength.name"
                  :label="consequenceStrength.strength.toString()"

                />
              </v-col>



            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn @click.prevent="historyBack">
                  {{$t("global.cancel")}}
                </v-btn>&nbsp;
                <v-btn type="submit" color="success">
                  {{$t("global.save")}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </material-card>

    </v-row>
  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import languageUtil from '../utils/language'

    export default {
        data() {
            return {
                consequenceStrengths:"",
            }
        },
        methods: {
            getConsequenceStrengths() {
                api.getConsequenceStrengths().then(response => {
                    this.consequenceStrengths= response
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            editConsequenceStrengths() {
                api.editConsequenceStrengths( this.consequenceStrengths).then(response => {
                  this.$router.push("/")
                    //   console.log(response.data)
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })


            }

        },
        mounted() {
            this.getConsequenceStrengths()
        }
    }
</script>
